import { appConfig } from '@common/config';
import { Category, type ICategoryProp } from '@components/Category';
import { Checkbox, type ICheckbox } from '@components/Checkbox';
import { OnOff, type IOnOffProp } from '@components/OnOff';
import { RangeSlider, type IRangeSliderProp } from '@components/RangeSlider';
import { type IPriceParams } from '@interface/IItemPrice';
import { useTranslation } from 'react-i18next';
import { FilterWrapTempl } from './FilterWrapTempl';

export const FilterWrapL2m = ({ props }: { props: IPriceParams }) => {
    const { t } = useTranslation();

    const gradeCheckProp: ICheckbox = {
        title: t('common.grade'),
        watch: 'grade',
        resetObj: { page: '1' },
        cls: 'grade',
        path: `/${appConfig.service}/v2.0/game/item/grade`,
        ga360str: '시세_조건검색_등급_클릭',
        activeChecked: props.paramGrade,
    };

    const rangeSliderProp: IRangeSliderProp = {
        watch1: 'enchantfrom',
        watch2: 'enchantto',
        min: 0,
        max: 11,
        step: 1,
        ga360str: '시세_조건검색_강화단계_클릭',
        activeEnchantfrom: props.paramEnchantfrom,
        activeEnchantto: props.paramEnchantto,
    };

    const onoffProp: IOnOffProp = {
        watch: 'sale',
        title: t('price.checksale'),
        initVal: 'true',
        resetObj: { page: '1' },
        description: t('common.showcurrentitems'),
        ga360str: '시세_조건검색_판매여부_클릭',
        activeChecked: props.paramSale,
    };

    const categoryProp: ICategoryProp = {
        title: t('common.category'),
        watchD1: 'category1',
        watchD2: 'category2',
        path: `/${appConfig.service}/v2.0/game/market/category`,
        ga360str: '시세_조건검색_카테고리_클릭',
        activeCategory1: props.paramCategory1,
        activeCategory2: props.paramCategory2,
    };

    return (
        <FilterWrapTempl refreshObj={refObj}>
            <Checkbox props={gradeCheckProp} />
            <RangeSlider props={rangeSliderProp} />
            <OnOff props={onoffProp} />
            <Category props={categoryProp} />
        </FilterWrapTempl>
    );
};

const refObj = {
    grade: '',
    sale: 'true',
    category1: '',
    category2: '',
    enchantfrom: '',
    enchantto: '',
    page: '1',
};
